import { render } from "./left-page.vue?vue&type=template&id=d674bb8c"
import script from "./left-page.vue?vue&type=script&lang=js"
export * from "./left-page.vue?vue&type=script&lang=js"
script.render = render

export default script